module.exports = __webpack_public_path__ + "static/img/Vector 5.cf5ed05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/Vector 5.png
// module id = rFvK
// module chunks = 1